<script context="module">
	import PaymentSettings from "./PaymentSettings.svelte";
	import {External as Ext} from "../../external";
	import {makeWebsiteRequest as makeRequest} from "../../Common/tools";

	let saveProduct = async (product, then) => {
		let result = await makeRequest({
			action: "saveStoreProduct",
			method: "post",
			data: {
				product: JSON.stringify(product)
			}
		});
		if (result.data === 'NO_STORE_ITEMS_AVAILABLE') {
      Ext.UITools.showNoMoreProductsDialog(() => {
        Ext.CPanel.goToUrl("/me/settings/billing");
      });
			then(null);
		} else {
			then(result.data);
		}
	}

	export function editPaymentSettings(item, type, onChange) {
		let product = null;
		Ext.Tools.showWindow({
			isModal: false,
			withDarkBackground: true,
			width: 520,
			buttons: [],
			noNav: true,
			noTitle: true,
			forceAtRight: window.showBuilderPopupsOnFullHeight,
			action: {
				onShow: (popup, ui) => {
					popup.bindComponent(
						new PaymentSettings({
							target: popup.getContentArea(),
							props: {
								item: item,
								type: type,
								onChange: (changedProduct) => {
									product = changedProduct;
								}
							}
						})
					);
				},
				onBeforeHide: (popup, ui, closeAction) => {
					if (product) {
						saveProduct(product, (product) => {
							if (product) {
								item.access = {
									...(item.access || {}),
									type: 'PAID',
									productId: product.id
								}
								onChange();
							}
							closeAction();
						});

						return false; // prevents the popup from closing while saving
					}
				}
			}
		});
	}
</script>
<script>

	import {onMount} from "svelte";
	import {External, M} from "../../external";
	import {ignore, makeWebsiteRequest} from "../../Common/tools";
	import Loader from "../../Common/Loader.svelte";
  import TagAndAutoresponderListPicker from '../../Common/TagAndAutoresponderListPicker.svelte';

	export let item,
		type = '',
		onChange = ignore;

	let product;
	let subscription = {
		enabled: false,
		period: 1,
		cycles: 0,
		periodUnit: 1
	}

	let loading = true;

	let createLmsProduct = () => {
		let url = 'payment-for-' + type.toLowerCase() + '-' + item.url + '-' + External.Tools.generateRandomString(4);
		return {
			id: -1,
			type: "paywall",
			title: item.name,
			description: {
				simple: true,
				text: M.SUBSCRIPTION_FOR + item.name
			},
			url: url,
			hidden: false,
			price: 1,
			salePrice: 0,
			onSale: false,
			sku: "",
			quantity: "",
			weight: 0,
			categories: [],
			variations: [],
			combinations: [],
			additions: {
				subscription: null
			}
		};
	}

	let setChanged = () => {
		product.additions = product.additions || {};
		product.additions.subscription = subscription?.enabled ? subscription : null;

		onChange(product);
	}

	let editSubscription = () => {
		let sub = {
			...subscription
		};

		let errorDisplay = "none";
		let error = "";
		if (!External.Website.storeSubscriptionAvailable) {
			errorDisplay = "block";
			error = External.Website.minPlanForStoreSubscriptions ? M.SUBSCRIPTIONS_MIN_AVAILABLE_PLAN + " " + External.Website.minPlanForStoreSubscriptions : M.SUBSCRIPTIONS_NOT_AVAILABLE;
		}

		External.Tools.showWindow({
			title: M.EDIT_SUBSCRIPTION,
			width: 400,
			markup: External.format(External.Templates.get("productSubscriptionEditDialog"), "errorDisplay", errorDisplay, "error", error),
			action: {
				onShow: function (popup, context) {
					popup.bindObject("data", sub, [
						{
							property: "cycles",
							type: "int"
						},
						{
							property: "period",
							type: "int"
						},
						{
							property: "periodUnit",
							type: "int"
						}
					]);
				}
			},
			buttons: [
				External.Button(External.Website.storeSubscriptionAvailable ? M.SUBMIT : M.UPGRADE_NOW, External.Button.CLASS_MIDDLE_BLUE, function (popup, context) {
					if (!External.Website.storeSubscriptionAvailable) {
						popup.close();
						External.CPanel.goToUrl("/me/settings/billing");
						return;
					}
					subscription = sub;
					popup.close();
					setChanged();
				}),
				External.Button.MIDDLE_CANCEL
			]
		});
	};

	let loadExistingProduct = async (productId) => {
		let result = await makeWebsiteRequest({
			action: "loadStoreProduct",
			data: {
				id: productId
			}
		});

		product = result.data.product;
    product.additions = product.additions || {};
		subscription = {
			...subscription,
			...(product.additions.subscription || {}),
		}
		subscription.enabled = product.withSubscription;
	}

	onMount(async () => {
		if (item.access?.productId) {
			await loadExistingProduct(item.access.productId);
		} else {
			product = createLmsProduct();
		}

		loading = false;
	})

</script>

<div class="popup-widget-wrapper">
	{#if loading}
		<Loader/>
	{:else}
		<div class="col20 f-left t-center mt-5">
			<span class="material-icons-outlined fingerprint-icon"> settings </span>
		</div>
		<h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.PAYMENT_SETTINGS}</h4>
		<div class="popup-input-wrapper">
			<h5>{M.PRODUCT_NAME}</h5>
			<input type="text" name="imageDescription" placeholder={M.ENTER_DISPLAY_NAME}
						 bind:value={product.title} on:change={setChanged}>
		</div>
		<div class="popup-input-wrapper mb-0">
			<h5>{M.PRICE_TO_ACCESS}</h5>
			<div class="symbol-input price-input"
           class:left-sign={External.Website.storeCurrencyPositionAtLeft}
           class:right-sign={!External.Website.storeCurrencyPositionAtLeft}>
				<span class="symbol-sign">{External.Website.storeCurrencySymbol}</span>
				<input type="number" min="0.01" step="1" placeholder="0.00" bind:value={product.price} on:change={setChanged}>
			</div>
		</div>
		<div class="col20 f-left mb">
			<div class="checkbox-wrapper">
				<input id="lmsPageRecurringFee" class="css-checkbox" type="checkbox" name="lmsPageRecurringFee"
							 bind:checked={subscription.enabled} on:change={setChanged}/>
				<label for="lmsPageRecurringFee" class="css-label">{M.RECURRING_FEE}
					<span>{M.RECURRING_FEE_DESC}</span>
				</label>
			</div>
		</div>
		{#if subscription.enabled}
			<div class="col20 f-left gray-section product-select-wrapper mb-15">
				<div class="col20 f-left ab-step center-vertically">
					<h4 class="roboto">{M.RENEWS_EVERY_MONTH}</h4>
					<a class="text-link blue-text" on:click={editSubscription}>{M.CHANGE}</a>
				</div>
			</div>
		{/if}
    <TagAndAutoresponderListPicker data={product.additions} onChange={setChanged} thirdPartyMarketing={false} label={M.WHEN_BOUGHT_TITLE} description={M.WHEN_BOUGHT_DESC} />
	{/if}
</div>
